let kom: KeyboardOrMouse = 'MOUSE';

export function initKeyboardOrMouse() {
    const mouseDownHandler = () => {
        kom = 'MOUSE';
    };

    document.addEventListener('mousedown', mouseDownHandler);

    const keyDownHandler = (event: KeyboardEvent) => {
        if (!['INPUT', 'TEXTAREA'].includes((event.target as HTMLElement).tagName)) {
            kom = 'KEYBOARD';
        }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
        document.removeEventListener('mousedown', mouseDownHandler);
        document.removeEventListener('keydown', keyDownHandler);
    };
}

export function getKeyboardOrMouse(): KeyboardOrMouse {
    return kom;
}

export type KeyboardOrMouse = 'MOUSE' | 'KEYBOARD';
